export const VARIANTS_QUERY = /* groq */ `
*[_type == "productVariantSection"][0]{
  heading,
  buttons[]{
    label,
    link{ href, newTab },
    style
  },
  productVariantItems[]{
    headline,
    description,
    variantValue,
    image{asset->{url}},
    campaignLink{href,newTab},
    productVariant->{
      name,
      image[]{asset->{url}},
      options[]->{ value, attribute->{name} }
    }
  }
}`;
